<div class="ts-page-header" [ngClass]="{ 'border-b border-black-200': displaySeparationBorder }">
  <div class="ts-page-header__header">
    <ng-content select="[page-header-title]"></ng-content>
    <ng-content select="[page-header-action-buttons]"></ng-content>
  </div>

  <div class="ts-page-header__action-bar">
    <ng-content select="[page-header-action-bar]"></ng-content>
  </div>
</div>
